module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-uso-912231bfef4d99facf55c4ea4b856ce4.svg";